import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=febbeb78&scoped=true&"
import script from "./SalesView.vue?vue&type=script&lang=js&"
export * from "./SalesView.vue?vue&type=script&lang=js&"
import style0 from "./SalesView.vue?vue&type=style&index=0&id=febbeb78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febbeb78",
  null
  
)

export default component.exports